import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bf95eec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-page ha-page" }
const _hoisted_2 = { class: "ha-signup l-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "新規会員登録", -1))
const _hoisted_4 = { class: "ha__sec ha-signup__sec" }
const _hoisted_5 = { class: "p-signup__field-container" }
const _hoisted_6 = { class: "p-errors" }
const _hoisted_7 = { class: "c-error" }
const _hoisted_8 = { class: "p-fields" }
const _hoisted_9 = { class: "c-field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "email"
}, "メールアドレス", -1))
const _hoisted_11 = { class: "c-field__body" }
const _hoisted_12 = { class: "c-field__input" }
const _hoisted_13 = { class: "ha__note" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("ドメイン指定受信をご利用の方は「mail.id.shueisha.co.jp」")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("をあらかじめ許可してください")
const _hoisted_16 = { class: "c-field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "password"
}, "パスワード", -1))
const _hoisted_18 = { class: "c-field__body" }
const _hoisted_19 = { class: "c-field__input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ha__note" }, "（英字大文字、英字小文字、数字を含む8文字以上）", -1))
const _hoisted_21 = { class: "c-field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "passwordRetype"
}, "パスワード（確認）", -1))
const _hoisted_23 = { class: "c-field__body" }
const _hoisted_24 = { class: "c-field__input" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ha-signup__note" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "ha-signup__discription" }, "上記のプライバシーガイドライン・各規約に同意のうえ")
], -1))
const _hoisted_26 = { class: "c-field has-submit" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "仮登録メールを送信", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "ha-signup__signin" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ha__txt" }, "下記サイトでのご登録がある、集英社IDをお持ちの場合は登録済みのメールアドレス・パスワードでログインいただけます。", -1))
const _hoisted_33 = { class: "ha-signup__service-list" }
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = {
  key: 1,
  class: "ha-signup__service-listitem"
}
const _hoisted_36 = ["src", "alt"]
const _hoisted_37 = { class: "c-field has-submit" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ログイン", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkageSignupProgress = _resolveComponent("LinkageSignupProgress")!
  const _component_Field = _resolveComponent("Field")!
  const _component_LinkageTerms = _resolveComponent("LinkageTerms")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_LinkageSignupProgress, { signupProgress: "Signup" }),
        _createVNode(_component_Form, {
          onSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.register, this))),
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(({ errors, meta }) => [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.errorMsgRef), 1)
              ], 512), [
                [_vShow, _ctx.errorMsgRef]
              ]),
              _createElementVNode("fieldset", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Field, {
                        type: "text",
                        id: "email",
                        name: "email",
                        modelValue: _ctx.cognitoInfo.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cognitoInfo.email) = $event)),
                        placeholder: "******@**.**.jp",
                        autocomplete: "email",
                        required: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("p", _hoisted_13, [
                      _hoisted_14,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailDomains, (value) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          _createTextVNode("「" + _toDisplayString(value) + "」", 1)
                        ], 64))
                      }), 256)),
                      _hoisted_15
                    ])
                  ])
                ]),
                _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.email), 513), [
                  [_vShow, errors.email]
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_Field, {
                        type: _ctx.passwordToggle.fieldType,
                        id: "password",
                        name: "password",
                        modelValue: _ctx.cognitoInfo.password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cognitoInfo.password) = $event)),
                        maxlength: _ctx.PASSWORD_MAX_LENGTH,
                        placeholder: "英字大小文字、数字を含む8文字以上",
                        autocomplete: "new-password",
                        required: ""
                      }, null, 8, ["type", "modelValue", "maxlength"]),
                      _createElementVNode("i", {
                        class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.passwordToggle.isOn }]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.passwordToggle)))
                      }, null, 2)
                    ]),
                    _hoisted_20
                  ])
                ]),
                _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.password), 513), [
                  [_vShow, errors.password]
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_Field, {
                        type: _ctx.passwordRetypeToggle.fieldType,
                        id: "passwordRetype",
                        name: "passwordRetype",
                        value: "",
                        maxlength: _ctx.PASSWORD_MAX_LENGTH,
                        placeholder: "パスワード確認",
                        autocomplete: "new-password",
                        required: ""
                      }, null, 8, ["type", "maxlength"]),
                      _createElementVNode("i", {
                        class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.passwordRetypeToggle.isOn }]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.passwordRetypeToggle)))
                      }, null, 2)
                    ])
                  ])
                ]),
                _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.passwordRetype), 513), [
                  [_vShow, errors.passwordRetype]
                ]),
                _createVNode(_component_LinkageTerms, { "initials-calss": 'ha-signup' }),
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "ha-btn is-submit",
                    disabled: !meta.valid || _ctx.isDeterringRef
                  }, _hoisted_29, 8, _hoisted_27)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"]),
        _createElementVNode("div", _hoisted_30, [
          (_ctx.store.state.siteLinkage.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("ul", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.siteLinkage, (site) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: site.link_id
                    }, [
                      (!!site.children)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(site.children, (child, idx) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: idx,
                              class: "ha-signup__service-listitem"
                            }, [
                              _createElementVNode("img", {
                                src: `${_ctx.logoImageBaseURL}logo_${site.link_id}_${child.linkage_sub_id}.svg`,
                                alt: child.name + '(' + child.name_jp + ')'
                              }, null, 8, _hoisted_34)
                            ]))
                          }), 128))
                        : (_openBlock(), _createElementBlock("li", _hoisted_35, [
                            _createElementVNode("img", {
                              src: _ctx.logoImageBaseURL + 'logo_' + site.link_id + '.svg',
                              alt: site.name + '(' + site.name_jp + ')'
                            }, null, 8, _hoisted_36)
                          ]))
                    ], 64))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_router_link, {
              class: "ha-btn",
              to: { name: _ctx.routeNames.LOGIN }
            }, {
              default: _withCtx(() => [
                _hoisted_38
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ])
  ]))
}